{
  "id": "pictureFrame",
  "name": "Picture Frame",
  "builds": "product",
  "category": "fineGoods",
  "note": "Eight 45° cuts that all have to agree.",
  "skill": "miteredFrames",
  "duration": 30,
  "offeredBy": "bench",
  "fastener": "nails",
  "value": 11,
  "widthIn": 24,
  "heightIn": 24,
  "slots": [
    {
      "id": "rail-0",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 24,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 12,
      "yIn": 0.5,
      "angleDeg": 90,
      "zIn": 0
    },
    {
      "id": "rail-1",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 24,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 12,
      "yIn": 23.5,
      "angleDeg": 270,
      "zIn": 0
    },
    {
      "id": "rail-2",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 24,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 0.5,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "rail-3",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 24,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 23.5,
      "yIn": 12,
      "angleDeg": 180,
      "zIn": 0
    }
  ],
  "fasteners": [
    {
      "xIn": 0.5,
      "yIn": 0.5
    },
    {
      "xIn": 23.5,
      "yIn": 0.5
    },
    {
      "xIn": 0.5,
      "yIn": 23.5
    },
    {
      "xIn": 23.5,
      "yIn": 23.5
    }
  ]
}
